import { ValueType } from '../models';

/**
 * Returns the ValueType associated with a column
 * @param data Table data
 * @param columnId column field
 * @returns ValueType derived from table data, defaults to string
 */
export const getColumnValueTypeFromData = (data: { [k: string]: unknown }[], columnId: string): ValueType => {
  for (const row of data) {
    const value = row[columnId];
    if (value != null) {
      if (typeof value === 'number') {
        return ValueType.NUMBER;
      }
      return ValueType.STRING;
    }
  }
  return ValueType.STRING;
};
